import _ from 'lodash';

import * as Account from 'app/entities/Account';
import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { partialWithDefault } from 'app/common/CommonUtils';

export const ACCEPTED = 'accepted';

export const type = 'offer';

export const api = buildEntityApi(type, (path, getState) => {
  const currentAccountId = Account.selectors.all.currentAccountId(getState());
  return `/api/v3/accounts/${currentAccountId}/offers/${path}`;
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.offer = _.partial(sel.dataItem, 'offer');
  sel.isAccepted = partialWithDefault(sel.stateItem, ACCEPTED, false);

  const hasOffer = (offerCode, entity) => sel.offer(entity) === offerCode;
  sel.all.byOfferCode = _.partial(sel.all.findBy, hasOffer);
});

export const actions = buildEntityActions(
  type,
  selectors,
  api,
  entityActions => {
    entityActions.markAsAccepted = _.partial(
      entityActions.updateEntityStateItem,
      ACCEPTED,
      true
    );

    entityActions.acceptOffer = offerCode => {
      return (dispatch, getState) => {
        return api.create({ offer: offerCode }, getState).then(() => {
          dispatch(entityActions.markAsAccepted(offerCode));
        });
      };
    };
  }
);
